export const stockTypeValues = [
  { value: "A", label: "Available" },
  { value: "P", label: "Physical" },
];
